import React from 'react';
import './App.css';
import Blockchain from './models/Blockchain.enum';
import TradingView from './components/TradingView';

const BLOCKCHAIN_MAP: Record<string, Blockchain> = {
  'solana': Blockchain.SOLANA,
  'ethereum': Blockchain.ETHEREUM,
};

function App() {
  const urlSearchParams = new URLSearchParams(window.location.search);

  const blockchainString = urlSearchParams.get('blockchain');
  const tokenAddress = urlSearchParams.get('tokenAddress');
  const poolAddress = urlSearchParams.get('poolAddress');
  const symbolName = urlSearchParams.get('symbolName');

  if (!blockchainString) {
    return (
      <div>Specify blockchain parameter!</div>
    );
  }

  const blockchain = BLOCKCHAIN_MAP[blockchainString];

  if (!blockchain) {
    return (
      <div>Incorrect blockchain parameter!</div>
    );
  }

  if (!symbolName) {
    return (
      <div>Specify symbolName parameter!</div>
    );
  }

  return (
    <TradingView
      blockchain={blockchain}
      tokenAddress={tokenAddress}
      poolAddress={poolAddress}
      symbolName={symbolName}
    />
  );
}

export default App;
